import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useLeasingCompanyDocumentsApi } from "../../http/leasingCompanyDocuments/api";
import { LeasingCompanyDocument } from "../../http/leasingCompanyDocuments/types";
import ModalDialog from "../ui/ModalDialog";

type DeleteLeasingCompanyDocumentDialogProps = {
  leasingCompanyDocument: LeasingCompanyDocument;
  onClose: () => void;
};

const DeleteLeasingCompanyDocumentDialog: FC<DeleteLeasingCompanyDocumentDialogProps> = ({
  leasingCompanyDocument,
  onClose,
}) => {
  const i18n = useI18n();
  const leasingCompanyDocumentsApi = useLeasingCompanyDocumentsApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.documents.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            leasingCompanyDocumentsApi
              .deleteLeasingCompanyDocument(leasingCompanyDocument.id, leasingCompanyDocument.leasingCompany.id)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.documents.questions.delete}
    </ModalDialog>
  );
};

export default DeleteLeasingCompanyDocumentDialog;
